import React, { useCallback } from "react"
import PropTypes from "prop-types"
import FormFieldset from "components/FormFieldset"
import GiftAidTooltip from "components/GiftAidTooltip"
import { FormControlLabel, Checkbox } from "@theconversation/ui"
import i18n from "lib/i18n"

const GiftAidCheckbox = (props) => {
  const { checked, onChange } = props

  const setGiftAid = useCallback((event) => onChange({ giftAid: event.target.checked }), [onChange])

  return (
    <FormFieldset>
      <FormControlLabel
        control={<Checkbox color="primary" checked={checked} onChange={setGiftAid} value="true" />}
        label={
          <>
            {i18n.t("donation.label.gift_aid_checkbox")}
            <GiftAidTooltip />
          </>
        }
      />
    </FormFieldset>
  )
}

GiftAidCheckbox.defaultProps = {
  checked: false,
  onChange: () => {},
}

GiftAidCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}
export default React.memo(GiftAidCheckbox)
